module.exports = __webpack_public_path__ + "static/media/ballooners.2d647dad.jpg";